var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjvu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 34,
    height: 15,
    rx: 2,
    fill: "#80869C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35 16V23H9.8C12.28 23 13.48 21.53 13.48 19.5C13.48 17.47 12.28 16 9.8 16H7.35ZM12.32 19.5C12.32 21.07 11.45 21.96 9.79 21.96H8.49V17.04H9.79C11.45 17.04 12.32 17.93 12.32 19.5ZM15.0252 16V17.05H16.9952V20.86C16.9952 21.77 16.3352 22.04 15.4952 22.04C14.9252 22.04 14.3552 21.89 13.9352 21.62V22.71C14.3852 22.96 15.0452 23.12 15.7352 23.12C17.0452 23.12 18.1352 22.51 18.1352 20.96V16H15.0252ZM23.0119 23L25.8319 16H24.6019L22.4219 21.68L20.2419 16H19.0119L21.8319 23H23.0119ZM31.5438 16V20.35C31.5438 21.62 30.7738 22.07 29.7038 22.07C28.6138 22.07 27.8438 21.62 27.8438 20.35V16H26.7038V20.41C26.7038 22.44 28.1438 23.13 29.7038 23.13C31.2538 23.13 32.6838 22.44 32.6838 20.41V16H31.5438Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjvu);
export default __webpack_public_path__ + "static/media/djvu.b0869776e48418ab62f6d82abcc96754.svg";
export { ForwardRef as ReactComponent };